import React from 'react'

import { Card, CardHeader, CardBody } from "reactstrap";

const FinancialChartLayout = (props) => {
  const { title, subtitle, range, expandClassName } = props;

  return (
    <Card>
      <CardHeader>
        <h5 className="h3 mb-0">{title}</h5>
        <div className="filter-container">
          <h6 className="subtitle">{subtitle}{range}</h6>
          <div className="date-filter text-right">
            {props.filter}
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <div className={expandClassName}>
          {props.children}
        </div>
      </CardBody>
    </Card>
  )
}

export { FinancialChartLayout }
